import { IsArray, IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import { Expose, Type } from "class-transformer";
import { Translation } from "@/models/api/Translation";
import { SERVICE_TYPE_GTU } from "@/static/ServiceTypeGTU";
import { SERVICE_CATEGORY } from "@/static/serviceCategory";

export class ServiceTypeFull {
  @IsOptional()
  @IsNumber()
  @Expose()
  id!: number | null;
  @IsString()
  @Expose()
  name!: string;
  @IsOptional()
  @IsString()
  @Expose()
  code!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  icon!: string | null;
  @IsString()
  @Expose()
  vat!: string;
  @IsNumber()
  @Expose()
  serviceCategory!: number;
  @IsOptional()
  @IsString()
  @Expose()
  unit!: string | null;
  // @IsString()
  // @Expose()
  // documentType!: string;
  @IsBoolean()
  @Expose()
  isLocked!: boolean;
  @IsBoolean()
  @Expose()
  isSplitPayment!: boolean;
  @IsBoolean()
  @Expose()
  isTourist!: boolean;
  @IsBoolean()
  @Expose()
  isReverseCharge!: boolean;
  @IsBoolean()
  @Expose()
  isSellerRequired!: boolean;
  @Expose()
  @IsOptional()
  @IsNumber()
  commissionServiceId!: number | null;
  @Expose()
  @IsOptional()
  @IsString()
  description!: string | null;
  @Expose()
  @IsOptional()
  @IsNumber()
  documentTypeId!: number | null;
  @Expose()
  @IsOptional()
  @IsNumber()
  fareBaseServiceId!: null | number;
  @Expose()
  @IsOptional()
  @IsNumber()
  feesAndTaxesServiceId!: null | number;
  // @Expose()
  // @IsString()
  // fiscalPrinterRegisterCode!: string;
  @Expose()
  @IsOptional()
  @IsNumber()
  finishServiceId!: null | number;
  @Expose()
  @IsOptional()
  @IsNumber()
  fiscalPrinterRegisterId!: number | null;
  @Expose()
  @IsOptional()
  gtu!: SERVICE_TYPE_GTU | null;
  @Expose()
  @IsOptional()
  @IsString()
  invoiceComment!: null | string;
  @Expose()
  @IsBoolean()
  isBooking!: boolean;
  @Expose()
  @IsBoolean()
  isCommission!: boolean;
  @Expose()
  @IsOptional()
  @IsString()
  pkWiU!: string | "";
  @Expose()
  @IsBoolean()
  serviceIsOnlyForThisOffice!: boolean;
  @Expose()
  @IsOptional()
  @IsString()
  publicProcurementXmlChargeCode!: string | null;
  @Expose()
  @IsOptional()
  @IsString()
  publicProcurementXmlDiscountCode!: string | null;
  @Expose()
  @IsOptional()
  @IsString()
  exemptionBasisComment!: string | null;
  @Expose()
  @Type(() => Translation)
  @IsArray()
  @ValidateNested()
  translations!: Array<Translation>;

  constructor() {
    // noinspection DuplicatedCode
    this.name = "";
    this.code = "";
    this.vat = "";
    this.isLocked = false;
    this.serviceCategory = SERVICE_CATEGORY.Sale;
    this.isReverseCharge = false;
    this.isSplitPayment = false;
    this.isSellerRequired = false;
    this.isTourist = false;
    this.unit = "";
    this.pkWiU = "";
    this.description = "";
    this.invoiceComment = "";
    this.fareBaseServiceId = null;
    this.feesAndTaxesServiceId = null;
    this.commissionServiceId = null;
    this.documentTypeId = null;
    this.gtu = null;
    this.isBooking = false;
    this.isCommission = false;
    this.serviceIsOnlyForThisOffice = false;
    this.fiscalPrinterRegisterId = null;
    this.translations = [];
    this.exemptionBasisComment = null;
  }
}
